import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { useLocation } from "react-router-dom";
import { CheckCircle2, Phone } from "lucide-react";
import Seo from "@/components/Seo";
import Cta from "@/components/Cta";
import { SITE } from "@/lib/site";
import { fbTrack, gaEvent } from "@/lib/track";

export default function ThankYou() {
  const location = useLocation();
  const fired = useRef(false);

  useEffect(() => {
    if (fired.current) return;
    const leadType = location.state?.lead;
    if (leadType) {
      fired.current = true;
      fbTrack("Lead", { content_name: leadType, content_category: "form" });
      gaEvent("generate_lead", { form_type: leadType, event_category: "lead", event_label: leadType });
    }
  }, [location.state]);

  return (
    <>
      <Seo title="Thank You | CYAN Wireless" description="Thanks for reaching out to CYAN Wireless. We'll be in touch shortly." path="/thank-you" />
      <section className="relative min-h-[80vh] grid place-items-center bg-ink-950 overflow-hidden pt-24">
        <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[500px] h-[500px] rounded-full bg-cyan-500/10 blur-[140px]" />
        <div className="relative z-10 text-center px-5 max-w-2xl">
          <motion.div initial={{ scale: 0, opacity: 0 }} animate={{ scale: 1, opacity: 1 }} transition={{ type: "spring", stiffness: 200, damping: 15 }} className="inline-grid place-items-center w-20 h-20 rounded-full bg-cyan-500/15 border border-cyan-500/30 text-cyan-400 mb-8">
            <CheckCircle2 size={40} />
          </motion.div>
          <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.15 }} className="font-display font-black text-5xl sm:text-6xl tracking-tighter text-white leading-[0.9]">
            You're all set.
          </motion.h1>
          <motion.p initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.25 }} className="mt-6 text-lg text-zinc-400">
            Thanks for reaching out to CYAN Wireless. A real, local person will follow up with you shortly. Need us sooner? Give us a call or text.
          </motion.p>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.35 }} className="mt-10 flex flex-wrap gap-4 justify-center">
            <Cta to="/">Back Home</Cta>
            <Cta href={`tel:${SITE.phoneRaw}`} variant="secondary"><Phone size={16} /> {SITE.phone}</Cta>
          </motion.div>
        </div>
      </section>
    </>
  );
}
